// | An implementation of Storage that uses `localStorage`, but ignores any errors.
// | 
// | Main use is caches - we don't want to use cookie fallback to avoid size limit issues.
import * as $runtime from "../runtime.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Foreign$dInternal$dStringify from "../Foreign.Internal.Stringify/index.js";
import * as Foreign$dJSON from "../Foreign.JSON/index.js";
import * as Restaumatic$dServices$dStorage from "../Restaumatic.Services.Storage/index.js";
import {getItem, setItem} from "./foreign.js";
const setJSONItem = dictEncode => v => value => setItem(v)(Foreign$dInternal$dStringify.unsafeStringify(dictEncode.encode(value)));
const readForeignMay = dictDecode => {
  const $0 = Foreign$dJSON.decodeJSONWith(dictDecode.decode);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Left") { return Data$dMaybe.Nothing; }
    if ($1.tag === "Right") { return Data$dMaybe.$Maybe("Just", $1._1); }
    $runtime.fail();
  };
};
const getJSONItem = dictDecode => v => {
  const $0 = getItem(v);
  return () => {
    const a$p = $0();
    return (() => {
      const $1 = Data$dNullable.nullable(a$p, Data$dMaybe.Nothing, Data$dMaybe.Just);
      const $2 = readForeignMay(dictDecode);
      if ($1.tag === "Just") { return $2($1._1); }
      if ($1.tag === "Nothing") { return Data$dMaybe.Nothing; }
      $runtime.fail();
    })();
  };
};
const localStorageNoFallback = /* #__PURE__ */ Restaumatic$dServices$dStorage.$Storage(dictDecode => getJSONItem(dictDecode), dictEncode => setJSONItem(dictEncode));
export {getJSONItem, localStorageNoFallback, readForeignMay, setJSONItem};
export * from "./foreign.js";
